import { jsx as t, jsxs as m } from "react/jsx-runtime";
import { d as i } from "../../vendor-EQDp64ng.js";
import { Image as o } from "../Image/index.js";
import '../../assets/index6.css';const d = "_avatar_s6vak_1", v = "_text_s6vak_26", n = {
  avatar: d,
  text: v
}, A = ({ src: e, textValue: c = "", alt: r = "" }) => {
  const a = i(n.avatar);
  if (r.trim().length)
    return /* @__PURE__ */ t("div", { className: a, "data-component": "Avatar", children: /* @__PURE__ */ t(o, { objectFit: "cover", alt: r, src: e }) });
  const s = c.trim();
  return s.length ? /* @__PURE__ */ m("div", { className: a, "data-component": "Avatar", children: [
    /* @__PURE__ */ t(o, { objectFit: "cover", alt: "", role: "presentation", "aria-hidden": "true", src: e }),
    /* @__PURE__ */ t("span", { className: n.text, children: s })
  ] }) : /* @__PURE__ */ t("div", { className: a, "data-component": "Avatar" });
};
export {
  A as Avatar
};
